<template>
  <div style="padding:40px;">
    <div class="txt_agreement">
      <h2 style="margin-top:0px;font-size:30px;">洪师傅代驾客户服务协议</h2>
      <p>洪师傅代驾平台（包括客户端手机软件、司机端手机软件、公众号、及电话服务系统）是由石狮洪师傅代驾有限公司开发的代驾信息服务平台，是为用户提供代驾信息服务的平台。用户通过本平台获得的代驾服务由洪师傅代驾当地合作的加盟商（以下简称“当地加盟商”）提供，代驾司机由当地加盟商指派。本协议适用于使用洪师傅代驾平台的用户与当地加盟商之间的权利和义务。</p>
    </br>
    <p>第一条 用户注册与资格 </br></br>
1.您注册时，请您认真阅读本协议，审阅并接受或不接受本协议。若您确认注册为本平台用户，即表示您已充分阅读、理解并同意自己与本平台订立本协议，且您自愿受本协议的条款约束。本平台有权随时根据实际情况变更本协议并在本平台上予以公告。经修订的条款一经在本平台的公布后，立即自动生效。如您不同意相关变更，必须停止使用本平台，并注销您的账户信息，一旦您继续使用本平台，则表示您已接受并自愿遵守经修订后的条款。本协议内容包括协议正文及所有本平台已经发布的各类规则。所有规则为本协议不可分割的一部分，与本协议正文具有同等法律效力。</br>
2.用户一经签署本协议，即视为用户允许洪师傅代驾通过短信、公众号、APP服务器推送或其他方式向其发送订单服务信息、优惠服务信息及与本协议相关的其他信息。</br>
3.用户应保证其注册信息的真实、准确、有效；如该等信息有任何变更，用户应当及时完成信息更新。因用户信息更新不及时所导致用户遭受任何损失的，应由用户自行承担责任，洪师傅代驾不承担责任。</br>
4、只有符合下列条件之一的自然人或法人才能申请成为本平台用户，可以使用本平台的服务：a、年满十八岁，并具有民事权利能力和民事行为能力的自然人；b、无民事行为能力人或限制民事行为能力人应事先取得其监护人的同意</br></br>
第二条 信息服务</br></br>
1.洪师傅驾平台为用户提供发送代驾请求（叫单）和接受该请求（接单）的信息推送服务，以及用户代驾订单履行情况的信息记录服务。</br>
2.代驾服务费收费标准由代驾服务提供商当地加盟商制定及调整。</br>
3.用户可通过洪师傅代驾平台对代驾服务行为作出评价或投诉，洪师傅代驾平台将用户评价和投诉实时反馈给代驾服务提供商当地加盟商。</br>
4.代驾服务费发票由洪师傅代驾当地提供服务的合作加盟商向您开具，发票的开具内容以当地服务为准，洪师傅代驾提供的代驾服务均不含税。</br>
</br>
第三条 双方的权利义务</br></br>
1.用户应确保提供给代驾司机代驾的车辆满足如下所有条件；如任一条件不满足，用户应如实告知当地加盟商指派的代驾司机，代驾司机有权拒绝该次服务。如因用户不主动告知或隐瞒以上情况带来的纠纷或者损害，洪师傅代驾及当地加盟商不承担任何责任及赔偿，由用户自行承担。</br>
（1）对代驾车辆有合法使用权；</br>
（2）车辆手续齐全（具备符合法律规定的号牌证、机动车登记证、行驶证等上路手续）；</br>
（3）车况正常，符合机动车国家安全技术标准，已按规定检验车辆并检验合格；</br>
（4）已购买机动车交通事故责任强制保险；</br>
（5）代驾车辆上路符合当地法律法规和政策，不违反针对尾号、高峰期、外地车等的行驶限制。</br>
2.洪师傅代驾及当地加盟商在如下情形下不承担责任：</br>
（1）不满足本协议第1条条件；</br>
（2）代驾服务过程中因用户及/或代驾车辆上人员（代驾司机除外）及/或代驾车辆本身原因导致发生的损失（包括但不限于政府部门罚款、代驾车辆上人员人身伤亡和财产损失、代驾车辆损失、代驾车辆上财产损失、任何第三方财产损失和人身伤亡损失）；</br>
（3）代驾车辆上违法、违章搭乘人员的人身伤亡；</br>
（4）代驾车辆上人员（代驾司机除外）因疾病、分娩、斗殴、自杀、犯罪行为造成的伤亡或损失；</br>
（5）用户财产及/或任何第三方财产因市场价格变动造成的贬值，修理后因价值降低引起的减值损失；</br>
（6)损失发生后，用户放任损失发生未进行必要修理或适当处理，致使损失扩大的部分。</br>
    (7) 如在代驾服务过程中发生交通事故，根据交警部门的交通事故责任认定，代驾服务司机存在过错的，报代驾险由其在交警部门认定的责任范围内承担责任；非代驾服务司机过错的，由代驾服务使用方自行向相应责任方进行追偿。</br>
</br>
    (8) 洪师傅代驾及驾驶员不承担责任项：代驾过程中因车辆自身故障造成的交通事故；因车辆爆胎造成的交通事故（爆胎为事故成因，区别于事故造成的爆胎）；车辆自燃、方向盘及刹车失灵、机件老化、自然灾害、外界掉落异物对车辆损伤、轮胎扎钉及压石子等；不可抗力因素造成的车辆损失，洪师傅代驾及驾驶员均不承担相应责任及赔偿义务。</br>
    (9) 您应当严格遵守本协议及本平台发布的其他协议、活动规则，因您违反协议或规则的行为给第三方、或本平台造成损失的，您应当承担全部责任。</br>
   (10) 用户不得利用洪师傅代驾平台骚扰、妨碍他人或从事任何违法或侵权行为（包括但不限于恶意叫单、恶意接单、多次销单等影响平台或其他用户的行为）。</br>
3.用户应妥善保管用户名及密码，不得将其赠与、转让、出售或出借与他人使用。如用户发现其用户名及密码遭他人使用，应立即通知洪师傅代驾平台方。因网络攻击、用户保管用户名及密码不当导致用户遭受任何损失的，应由用户自行承担责任，洪师傅代驾不承担责任。</br>
4.用户在接受代驾服务前，应根据洪师傅代驾平台提供的代驾司机信息核实司机身份。用户接受非洪师傅代驾平台司机代驾服务所造成的任何纠纷或遭受的任何损失，洪师傅代驾公司和当地加盟商均不承担任何责任及赔偿责任。</br>
5.代驾服务开始时和结束时，用户须检查车上的贵重财物，如有财物毁损灭失应及时提出。代驾服务结束司机离开之前，用户未提出任何财物毁损灭失异议的，即视为本次服务过程中没有发生财物毁损灭失情况。</br>
6.用户在洪师傅代驾平台发布的内容应当客观真实，不得包含辱骂、诋毁以及法律禁止性信息。</br>
7.用户与代驾司机个人达成的承诺、责任分担协议、和解协议，应由代驾司机个人承担相关责任，与洪师傅代驾及/或当地加盟商无关，洪师傅代驾公司或当地加盟商仅就本协议提及责任和义务承担责任。</br>
8.用户没有通过洪师傅代驾平台而私下接受代驾司机提供服务的，该服务内容、因该服务发生或与该服务有关的任何争议或责任均与洪师傅代驾及当地加盟商无关。</br>
9.洪师傅代驾公司仅为用户提供信息服务，并不实际提供也不代理任何服务方提供代驾服务。除本协议载明由洪师傅代驾平台承担的责任外，洪师傅代驾有限公司不对代驾服务中产生的争议或纠纷承担责任，也不对用户使用代驾服务过程中遭受的损失承担责任。</br>
第四条 知识产权</br>
1.洪师傅代驾平台包含的所有内容，包括但不限于著作、文本、图形、图片、档案、资讯、资料、网站架构、网站画面的安排、网页设计、标志及软件，均由洪师傅代驾拥有知识产权（包括但不限于商标权、专利权、著作权、商业秘密），未经洪师傅代驾公司同意，任何人不得使用、修改、方向工程、复制、公开传播、改变、散布、发行或公开发表。</br>
2.洪师傅代驾平台运营数据的全部权利属于石狮洪师傅代驾有限公司。前述运营数据包括但不限于用户注册信息、行车里程、行车地点等数据。</br>
第五条 其他</br>
1.用户使用洪师傅代驾平台（包括但不限于通过洪师傅代驾平台寻求代驾服务、接受代驾服务或注册洪师傅代驾公众号、APP），即视为同意受本协议之约束。本协议经用户通过网络点击同意之时生效，并本协议取代合同双方之前订立的洪师傅代驾用户平台使用协议。本协议生效后永久有效，客户使用洪师傅代驾平台均受本协议之约束。</br>
2.洪师傅代驾有限公司有权对本协议内容进行修改并无需逐一通知用户，最新版本之服务协一经发布即视为已通知所有用户。客户不同意该修改的，应停止使用洪师傅代驾平台服务。客户继续使用洪师傅代驾信息服务的，视为同意该修改。为确保客户查阅最新版协议，洪师傅代驾有限公司将向寻求代驾服务的用户短信通知本协议及其最新版本，客户收到该短信通知后仍接受代驾服务即视为同意本协议及其最新版本。</br>
3.因本协议产生或与本协议有关的任何争议，任一方均可向洪师傅代驾住所地人民法院诉讼解决。</p>
    </div>
  </div>
</template>
<script>
export default {
  name: "agreement"
};
</script>
<style lang="less">
.txt_agreement {
  h2 {
    margin-bottom: 20px;
  }
  p {
    line-height: 40px;
    text-align: justify;
    font-size: 24px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/agreement/index.vue